module.exports = __webpack_public_path__ + "static/media/footer_govolegal.f28a018f.gif";